import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class UpdateBijbEventAction implements Action {
  public static readonly type = 'UpdateBijbEventAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = UpdateBijbEventAction.type;
}
